var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NoSsr',[_c('div',{staticClass:"molecule-content-slider-brochure"},[_c('VSplide',{ref:"carousel",staticClass:"owl-carousel owl-theme",attrs:{"options":_vm.options}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }